module.exports = __webpack_public_path__ + "static/media/sort-size-up-alt.0b1cda8e.svg";